import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import services from './services.js';
//组件
import baseInfoForm from '../agent-base-infonew';
import contactForm from '../agent-contactnew';
import agentInfo from '../agent-infonew';
import operateAddressDialog from 'operateAddressDialog';
import selectStaffDialog from 'selectStaffDialog';

//import address from 'agent-address';
//import agentSignMaterielv from 'agent-sign-materiel';
export default {
    mixins: [services],
    components: {
        'base-info-form': baseInfoForm,
        'contact-form': contactForm,
        'agent-info': agentInfo,
        operateAddressDialog,
        selectStaffDialog,
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            choiceAgentInfoIndex: '',
            agentInfoNum: 1,
            agentList: [{}],
            baseInfo: null,
            contact: null,
            address: null,
            materiel: null,
            id: 0,
            title: '',
            isReadOnly: false,
            form: this.getFormData(),
            isChange: false, // 修改入口
            dialogObj: '', //判断是招商还是业务经理
            isRequired: false, //判断必填字段
            refContact: 'contactBefore', //用来判断联系人组件位置
            isPerson: true, //判断个人
            isAddBtnShow: [true],
            isDelBtnShow: [false],
            ListDoubtTypes: [{
                id: 1,
                value: '基本信息'
            }, {
                id: 2,
                value: '主联系人信息'
            }, {
                id: 3,
                value: '合作信息'
            }],
            conpanyInfoReadOnly: true,
            contactInfoReadOnly: true,
            coopInfoReadOnly: true,
            contactProvId: '',
            contactCityId: '',
            contactAreaId: '',
            contactStorageArea: this.getStorageAreaData() //存储个人信息的省市区（获取单条时候存储）
        };
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    watch: {

    },
    methods: {
        getFormData() {
            return cloneDeep({
                Industry_Id: 9,
                Contact: {},
                Customer: {},
                TimeStamp: ''
            });
        },
        getStorageAreaData() {
            return cloneDeep({
                ProvId: '',
                CityId: '',
                AreaId: ''
            });
        },
        show(options) {
            this.dialogVisible = true
            this.coopInfoReadOnly = true
            this.contactInfoReadOnly = true
            this.conpanyInfoReadOnly = true
            this.title = options.title
            this.agentList = [{}]
            this.baseInfo = null
            this.contact = null
            this.id = 0
            this.isReadOnly = options.isReadOnly
            this.$nextTick(() => {
                this.form = this.getFormData()
                this.contactStorageArea = this.getStorageAreaData()
                this.$refs.baseInfo.resetFields();
                this.$refs.contactBefore.resetFields();
                this.$refs.contactAfter.resetFields();
                this.agentList = [{}];
                for (let i = 0; i < this.agentList.length; i++) {
                    this.$refs['agentInfo' + (i + 1)][0].resetFields();
                }

                this.agentInfoNum = 1;
            })
            if (options.Id) {
                this.id = options.Id
                // 修改审核获取单条
                this.GetById()
                this.form.Id = this.id


            }

        },
        changeAgentType(val) {

            if (this.contactProvId !== '') {
                this.baseInfo == null
            }
            if (val == 14) {
                // 公司
                this.refContact = 'contactAfter'
                this.isRequired = true
                this.isPerson = false
            } else {
                // 个人
                this.isPerson = true
                this.refContact = 'contactBefore'
                this.isRequired = false
            }
        },
        showSelectStaffDialog(val) {
            this.dialogObj = val
            this.$refs.refSelectStaffDialog.show();
        },
        //选择员工
        selectedStaff(item) {
            if (item !== undefined) {
                if (this.dialogObj == 'Manager') {
                    // 招商经理信息
                    this.$refs.baseInfo.setStaffInfo2(item);
                } else {
                    this.$refs.baseInfo.setStaffInfo(item);
                }
            }

        },
        // 代理类型为个人时公司地址信息自动默认联系人地址信息
        getProvId(val) {
            this.contactProvId = '';
            this.contactCityId = '';
            this.contactAreaId = '';
            if (this.form.Industry_Id == 9) {
                this.contactProvId = val

            }
        },
        getCityId(val) {
            if (this.form.Industry_Id == 9) {
                this.contactCityId = val
                if (this.id == 0) {
                    // 新增入口
                    this.baseInfo = {
                        ProvId: this.contactProvId,
                        CityId: this.contactCityId,
                    }
                } else if (this.contactStorageArea.ProvId !== this.contactProvId) {
                    // 修改时候切换联系人省市区
                    this.baseInfo.ProvId = this.contactProvId
                    this.baseInfo.CityId = this.contactCityId
                    this.baseInfo.AreaId = ''
                }

            }
        },
        getAreaId(val) {
            if (this.contactCityId !== '' && this.form.Industry_Id == 9) {
                this.contactAreaId = val
                if (this.id == 0) {
                    // 新增入口
                    this.baseInfo = {
                        ProvId: this.contactProvId,
                        CityId: this.contactCityId,
                        AreaId: val
                    }
                } else if (this.contactStorageArea.AreaId !== this.contactAreaId) {
                    // 修改时候切换联系人省市区
                    this.baseInfo.AreaId = this.contactAreaId
                }


            }
        },
        //关闭弹窗
        close() {
            this.dialogVisible = false;
        },
        //添加代理基本信息
        addAgentObj() {
            this.agentList.push({});
        },
        addAgent() {
            this.agentInfoNum += 1;
        },
        delAgentfn(item) {
            this.agentList.splice((item.index - 1), 1);
        },

        submit() {

            this.$nextTick(() => {
                // 新增 修改提交
                let contact = false
                let baseInfo = false

                if (this.form.Industry_Id == 9) {
                    // 先判断联系人信息
                    contact = this.$refs[this.refContact].validate(); //联系人信息
                    if (contact) {
                        baseInfo = this.$refs.baseInfo.validate(); //公司基本信息
                    }
                } else {
                    // 先判断公司信息
                    baseInfo = this.$refs.baseInfo.validate(); //公司基本信息
                    if (baseInfo) {
                        contact = this.$refs[this.refContact].validate(); //联系人信息
                    }
                }
                let ListAgentAreas = [];
                if (baseInfo) {
                    //合作信息
                    for (let i = 0; i < this.agentList.length; i++) {
                        let dataArea = this.$refs['agentInfo' + (i + 1)][0].validate();
                        ListAgentAreas.push(dataArea);
                    }
                }
                let agentInfoResult = ListAgentAreas.every(function (result) {
                    return result;
                });
                if (!!baseInfo && !!contact && agentInfoResult) {
                    this.form.Contact = cloneDeep(contact)
                    this.form.Customer = cloneDeep(baseInfo)
                    this.form.List = cloneDeep(ListAgentAreas)
                    if (this.id != 0) {
                        // 修改
                        this.NewCustomerModify(this.form)
                    } else {
                        // 新增
                        this.NewCustomerAdd(this.form)
                    }
                }
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/apply-dialog/vm.js